import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bem } from '@argos/utils'

import { Creators as MessagingCreators } from '../Core/Messaging'

import { Forms } from '../Forms'

import { Disconnect, EndPrompt, MessageForm } from './components'
import { ControlsCreators } from '../actions'

const cn = bem({ prefix: 'lc-', block: 'controls' })

export class Controls extends React.Component {
  static propTypes = {
    activeControl: PropTypes.oneOf(['Messenger', 'ExitPrompt', 'Form', 'WaitingRoom']).isRequired,
    chatEndInfo: PropTypes.shape({
      alternateChannels: PropTypes.shape({
        facebook: PropTypes.shape({
          enabled: PropTypes.bool,
          url: PropTypes.string,
        }),
        telephone: PropTypes.shape({
          enabled: PropTypes.bool,
          number: PropTypes.string,
        }),
        twitter: PropTypes.shape({
          enabled: PropTypes.bool,
          url: PropTypes.string,
        }),
      }),
      ended: PropTypes.bool,
      reason: PropTypes.string,
    }),
    chatId: PropTypes.string,
    hasError: PropTypes.bool,
    isReconnecting: PropTypes.bool,
    newMessage: PropTypes.string,
    currentQuestion: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
    onUpdateMessage: PropTypes.func.isRequired,
    onSubmitMessage: PropTypes.func.isRequired,
    onSubmitAnswer: PropTypes.func.isRequired,
    onUpdateRef: PropTypes.func.isRequired,
  }

  static defaultProps = {
    chatEndInfo: {},
    hasError: false,
  }

  handleSubmit = (evt) => {
    evt.preventDefault()

    const { newMessage, onSubmitMessage, onSubmitAnswer, chatId, currentQuestion } = this.props

    if (newMessage && newMessage.trim()) {
      if (currentQuestion && currentQuestion.id) {
        onSubmitAnswer({
          chatId,
          value: newMessage,
          id: currentQuestion.id,
        })
      } else {
        onSubmitMessage({
          chatId,
          body: {
            type: 'TEXT',
            text: newMessage,
          },
          participant: {
            type: 'CUSTOMER',
          },
        })
      }
    }
  }

  render() {
    const {
      activeControl,
      chatEndInfo,
      hasError,
      newMessage,
      isReconnecting,
      onUpdateMessage,
      onUpdateRef,
      complexState,
      currentQuestion,
      complexChange,
      messages,
    } = this.props
    const { alternateChannels, ended = false, reason } = chatEndInfo

    const focusInput = !!(currentQuestion && currentQuestion.id)

    const showEndPrompt = (hasError || ended) && activeControl !== 'ExitPrompt'
    const showDisconnect = isReconnecting && activeControl !== 'ExitPrompt'
    const showMessenger = !showEndPrompt && !showDisconnect && activeControl === 'Messenger' && !complexState
    const showForms = !showEndPrompt && !showDisconnect
    const FormElement = (
      <div className={cn()} data-test={cn()} ref={onUpdateRef}>
        <MessageForm
          newMessage={newMessage}
          onChange={onUpdateMessage}
          onSubmit={this.handleSubmit}
          focusInput={focusInput}
        />
      </div>
    )

    const FlexibleFormElements = (
      <div className={cn()} data-test={cn()} ref={onUpdateRef}>
        <div className={cn('container')}>
          {showForms && <Forms />}
          {showDisconnect && <Disconnect />}
          {!showDisconnect && showEndPrompt && reason && (
            <EndPrompt message={reason} alternateChannels={alternateChannels || undefined} />
          )}
        </div>
      </div>
    )

    const lastMessage = Array.isArray(messages) && messages.length > 0 ? messages[messages.length - 1] : null
    const hideInput = currentQuestion && currentQuestion.type === 'SINGLE_OPTION'
    if (lastMessage && lastMessage.type === 'system') {
      complexChange(hideInput)
    }

    if (showMessenger) {
      return FormElement
    }

    return FlexibleFormElements
  }
}

const mapStateToProps = (state) => ({
  activeControl: state.Controls.activeControl,
  complexState: state.Controls.complexState,
  chatEndInfo: state.Chat.chatEndInfo,
  chatId: state.Chat.chatId,
  hasError: state.Api.error || state.Socket.hasError,
  isReconnecting: state.Socket.pingResponseError || state.Socket.isReconnecting,
  newMessage: state.Messaging.newMessage,
  currentQuestion: state.Forms.currentQuestion,
  messages: state.Messaging.messages,
})

const mapDispatchToProps = (dispatch) => ({
  onUpdateMessage: (evt) => dispatch(MessagingCreators.updateMessage(evt.target.value)),
  onSubmitMessage: (message) => dispatch(MessagingCreators.submitMessage(message)),
  onSubmitAnswer: (answer) => dispatch(MessagingCreators.submitAnswer(answer)),
  onFormChange: (lastActiveControl) => dispatch(ControlsCreators.setActiveControl(lastActiveControl)),
  complexChange: (complexState) => dispatch(ControlsCreators.setComplexStage(complexState)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Controls)
